import { DeviceType, ProductCarouselType } from '@/enums';
import { CollectionTabProperty, ICollectionProperty, IKeyBannerProperty } from '@/interfaces/homepage';
import { IProductList, IProductListPayload, IProductModel, IProductSlide } from '@/interfaces/product';
import { getProducts } from '@/services/product.service';

export const homepageCollectionItems = (collectionItems?: ICollectionProperty[]) => {
  const tabs: CollectionTabProperty[] = [];
  collectionItems?.sort((a, b) => (a.DisplayOrder > b.DisplayOrder ? 1 : -1));
  collectionItems?.forEach((collection) => {
    tabs.push({
      label: collection?.Name,
      tags: collection?.Id,
      seName: collection?.SeName,
      queryParams: collection?.QueryParams,
    });
  });
  return tabs;
};
export const homepageCollectionSliderData = (collectionData?: IProductList) => {
  let data: IProductSlide[] = [];
  collectionData?.PageData?.forEach((element) => {
    data.push({
      id: element?.Id,
      seName: element?.SeName,
      name: element?.Name,
      CategoryName: element?.CategoryName,
      FeaturedImageUrl: element?.FeaturedImageUrl,
      options: element?.Colors,
      productPrice: { OldPrice: element?.ProductPrice?.OldPrice, Price: element?.ProductPrice?.Price },
      altText: element?.AltText,
    });
  });
  return data;
};

export const homepageProductCarouselSliderData = (productSliderData?: IProductModel[]) => {
  let data: IProductSlide[] = [];
  productSliderData?.forEach((element) => {
    data.push({
      id: element.Id,
      seName: element?.SeName,
      name: element?.Name,
      FeaturedImageUrl: element.FeaturedImageUrl,
      options: element?.Colors,
      productPrice: { OldPrice: element?.ProductPrice?.OldPrice, Price: element?.ProductPrice?.Price },
      altText: element?.AltText,
    });
  });
  return data;
};
export const getProductsCarousel = async (id: string, type: ProductCarouselType) => {
  const carouselProductsPayload: IProductListPayload = {
    categoryIds: type === ProductCarouselType.Category ? [id] : [],
    brandId: type === ProductCarouselType.Brand ? id : undefined,
    includeOutOfStockProducts: false,
    showDefaultImageOnly: true,
  };
  let carouselProducts: IProductList = await getProducts(12, 1, carouselProductsPayload);
  return carouselProducts;
};

export const getKeyBannerInfo = (bannerInfo: IKeyBannerProperty[],deviceType:DeviceType) => {
  const filteredData = bannerInfo?.find((item) => item?.Device === deviceType);
  return filteredData;
};

